import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { API_CODE } from "../../common/utils/const";
import { authServ } from "../../services";
import { authAct } from "../../store/actions";

export default function Redirect() {
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();

  useEffect(() => {
    init();
  }, []);

  const init = async () => {
    const params = {
      state: searchParams.get("state") || "",
      code: searchParams.get("code") || "",
      client_info: searchParams.get("client_info") || "",
    };
    const { data, errMsg, errCode } = await authServ.redirect(params);

    if (errCode == API_CODE.SUCCESS) {
      const userInfo = {
        auth: "",
        profile: data,
      };

      localStorage.setItem("USER", JSON.stringify(userInfo));
      dispatch(authAct.loginSuccess(userInfo));
    }
  };

  /**
   * renders
   */
  return <div></div>;
}
